import { useEffect } from 'react'
import { useAuthContext } from 'shared/components/AuthContext'
import {
  exitSystemAdminMode,
  needsTwoFactorEnrollment,
  useIsSystemAdminMode,
} from 'shared/utils'

// Leaves the system admin mode entered without 2FA, e.g. with a cookie set by
// hand or before 2FA was required
export const useSystemAdminModeTwoFactorGuard = () => {
  const { user, auth } = useAuthContext()
  const isSystemAdminMode = useIsSystemAdminMode()

  useEffect(() => {
    if (!isSystemAdminMode || !user || !auth) return
    if (!needsTwoFactorEnrollment(user)) return

    let cancelled = false

    // The SDK may lack the factors only because it couldn't load them (e.g.
    // offline), so the mode is left once the server confirms they are missing
    auth
      .reloadUserWithTokenRefresh()
      .then(() => {
        const reloadedUser = auth.getCurrentUser()
        if (cancelled || !reloadedUser) return

        if (needsTwoFactorEnrollment(reloadedUser)) exitSystemAdminMode()
      })
      .catch(() => undefined)

    return () => {
      cancelled = true
    }
  }, [auth, isSystemAdminMode, user])
}
